"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var typography = _ref.typography,
    palette = _ref.palette;
  return {
    menuButton: {
      fontFamily: typography.fontFamily,
      fontSize: '13px',
      backgroundColor: '#1E8777',
      color: '#ffffff',
      padding: '16px',
      borderRadius: '10px',
      height: '44px',
      fontWeight: typography.fontWeightRegular,
      '&:hover': {
        backgroundColor: palette.primary.dark
      },
      '&:disabled': {
        backgroundColor: palette.primary.light,
        color: 'rgba(255, 255, 255, 0.4)'
      }
    },
    buttonIconAPMenu: {
      marginLeft: '10px',
      width: '12px',
      height: '12px'
    },
    menuButtonAPMenu: function menuButtonAPMenu(props) {
      return {
        height: '44px',
        padding: ' 16px',
        fontFamily: "'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif",
        fontSize: '13px',
        textTransform: 'none',
        backgroundColor: props.actions ? 'unset' : '#F7F7F7',
        color: ' #212529',
        borderRadius: props.actions ? '5px' : '10px',
        fontWeight: typography.fontWeightRegular,
        '&:hover': {
          backgroundColor: '#C4C4C4'
        },
        '&:disabled': {
          backgroundColor: 'rgb(210, 210, 210)',
          color: 'rgba(255, 255, 255, 0.4)'
        }
      };
    },
    spacer: {
      margin: '0 8px'
    },
    buttonIcon: {
      marginLeft: 18
    },
    menuIconWrapper: {
      height: '100%',
      width: '100%',
      '&:hover svg': {
        color: 'rgba(51, 51, 51, 1)'
      }
    },
    menuIcon: {
      height: '14px'
    },
    filterMenuIconWrapper: {
      background: '#F7F7F7',
      height: '44px',
      width: '78px',
      textTransform: 'none',
      '&:hover svg': {
        color: 'rgba(51, 51, 51, 1)'
      },
      padding: '16px'
    },
    filterMenuTitle: {
      fontFamily: 'Source Sans Pro',
      marginLeft: '10px',
      fontWeight: typography.fontWeightRegular,
      fontSize: '13px',
      '&:hover ': {
        color: 'rgba(51, 51, 51, 1)'
      }
    },
    menuContainer: {
      '& .MuiMenu-paper': {
        top: '50px!important'
      }
    },
    menuList: {
      '& .MuiMenu-paper': {
        '& .MuiList-padding': {
          paddingTop: '0',
          paddingBottom: '0'
        }
      }
    }
  };
}, {
  name: 'APFilterMenu'
});
var _default = useStyles;
exports["default"] = _default;